import { Flex } from '@chakra-ui/layout';
import styled from 'styled-components';
import { Checkbox as CheckboxComponent } from '@chakra-ui/react';

export const Wrapper = styled(Flex)`
  width: 100%;
  flex-direction: column;
  /* border: 1px solid red; */
  height: 100vh;
`;

export const ContainerHeader = styled.header`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1000;

  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 4rem;
  background: ${({ theme }) => theme.colors.white};

  box-shadow: 1px 0px 13px 0px #0000004d;

  svg {
    height: 2.3rem;
  }
`;

export const WrapperMain = styled.main`
  width: 100%;
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  margin-top: 4rem;
  background-color: ${({ theme }) => theme.colors.grey};
`;

export const FirstLine = styled(Flex)`
  width: 100%;
  height: 79vh;
  overflow: hidden;
`;

export const SecondLine = styled(Flex)`
  width: 100%;
  /* height: 100vh; */
`;

export const WrapperContent = styled(Flex)`
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const ContainerContent = styled(Flex)`
  width: 22rem;
  flex-direction: column;
  padding-block: 3.5rem;

  h1 {
    color: ${({ theme }) => theme.colors.tertiary};
    line-height: 3.7rem;
    margin-bottom: 2rem;
    font-size: 3rem;
  }

  a {
    color: white;
    background: ${({ theme }) => theme.colors.tertiary};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.23rem;
    width: 8rem;
    height: 2rem;
  }
`;
export const WrapperImage = styled(Flex)`
  position: relative;
  width: 100%;

  .circleGeometric {
    width: 50.25rem;
    height: 50.25rem;
    background: ${({ theme }) => theme.colors.tertiary};

    shape-outside: circle(60% at 10%);
    clip-path: circle(50% at 27%);
    transform: rotate(180deg);

    position: absolute;
    right: 0rem;
    top: -4rem;
    overflow: hidden;
    z-index: 1;
  }

  img {
    z-index: 2;
    position: absolute;
    /* top: 0rem; */
    right: 0rem;
    bottom: 0rem;
    height: 37rem;

    width: 70%;
  }
`;

export const WrapperFooter = styled.footer`
  background: #000;
  z-index: 2;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem 16rem;
  height: 100%;

  /* position: relative; */

  svg {
    align-content: flex-start;
    margin-bottom: 3rem;
    width: 11.5rem;
  }

  .copyRight,
  .terms {
    color: ${({ theme }) => theme.colors.white};
    font-size: 0.85rem;
  }

  .copyRight {
    margin-bottom: 1rem;
  }

  .terms > a {
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const WrapperFooterContent = styled(Flex)`
  justify-content: space-between;
  gap: 10rem;

  margin-bottom: 3rem;
`;

export const ContainerFooterContent = styled.div`
  p {
    text-align: center;
    color: ${({ theme }) => theme.colors.secondary};
    font-weight: 500;
  }

  address {
    font-size: 0.85rem;
    text-align: center;
    color: ${({ theme }) => theme.colors.white};
    font-style: normal;
  }
`;

export const WrapperMainTerms = styled.main`
  padding: 4.312rem 11.06rem;

  h1 {
    color: ${({ theme }) => theme.colors.tertiary};
    line-height: 2rem;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1.5rem;
    color: #333333;
  }
  ul,
  li {
    margin-bottom: 1.5rem;
    color: #333333;
  }
`;

export const WrapperForm = styled.form<any>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Checkbox = styled(CheckboxComponent)<any>`
  margin-bottom: 21px;

  .chakra-checkbox__control {
    box-shadow: none !important;
    border: 2px solid #333;

    height: 1rem;
    width: 1rem;

    &[data-checked] {
      border: 1px solid ${({ theme }) => theme.colors.tertiary};
      background-color: ${({ theme }) => theme.colors.tertiary};

      &:hover {
        background-color: ${({ theme }) => theme.colors.tertiary} !important;
      }
    }
  }

  .chakra-checkbox__label {
    margin-bottom: auto;
    margin-top: auto;
    margin-left: 12px;

    height: 23px;

    font-size: 14px;
    color: ${({ theme }) => theme.colors.black700};
    span {
      a {
        color: ${({ theme }) => theme.colors.black700};
      }
    }

    &[data-checked] {
      color: ${({ theme }) => theme.colors.black700};

      span {
        font-weight: bold;

        a {
          color: ${({ theme }) => theme.colors.black700};
        }
      }
    }
  }
`;
